<suite-rfb-table #tabela
                 class="tabela-detalhes-cores-alternadas"
                 [class.tabela-sem-filtro]="!this.exibirFiltros"
                 [key]="this.key"
                 [pageSizes]="this.pageSizes"
                 [pageSize]="this.pageSize"
                 [rows]="this.rows"
                 [columns]="this.columns"
                 [externalPaging]="this.externalPaging"
                 [itemsAmount]="this.itemsAmount"
                 [currentPage]="this.currentPage"
                 [title]="this.title"
                 [emptyMessage]="this.emptyMessage"
                 [headerHeight]="this.headerHeight"
                 [rowHeight]="this.rowHeight"
                 [rowDetailHeight]="this.rowDetailHeight"
                 [columnMode]="this.columnMode"
                 [detailTemplate]="this.detailTemplate"
                 [summaryRow]="this.summaryRow"
                 [summaryPosition]="this.summaryPosition"
                 [summaryHeight]="this.summaryHeight"
                 [rowClass]="this.rowClass"
                 [scrollbarH]="this.scrollbarH"
                 [scrollbarV]="this.scrollbarV"
                 [selectAllRowsOnPage]="this.selectAllRowsOnPage"
                 [selectionType]="this.selectionType"
                 [headerSelectable]="this.headerSelectable"
                 [selected]="this.selected"
                 [displayCheck]="this.displayCheck"
                 [filterRowFn]="this.filterRowFn"
                 [sortable]="this.sortable"
                 [externalSorting]="this.externalSorting"
                 [virtualization]="this.virtualization"
                 [rowIdentity]="this.rowIdentity"
                 [tableStyle]="this.tableStyle"
                 [trackByProp]="this.trackByProp"
                 [showPagination]="this.showPagination"
                 [showFiltersStats]="this.showFiltersStats"
                 [builtinActions]="this.builtinActions"
                 [footerText]="this.footerText ?? this.defaultFooterText"
                 [footerHeight]="this.footerHeight">
</suite-rfb-table>